document.addEventListener('DOMContentLoaded', function () {
  const main = document.querySelector('main.collection')
  if (!main) return

  const mainTabButtons = main.querySelectorAll('.sec01 .js_tab_btn')
  const mainTabContents = main.querySelectorAll('.js_tab_content')
  const tabTitles = main.querySelectorAll('.js_tab_title')
  const tabInput = main.querySelector('.search_form input[name="tab"]')
  const searchForm = main.querySelector('.search_form')
  const scrollStorageKey = 'hirayama_collection_scroll_to_tab_contents'

  function getHeaderHeight() {
    const header = document.querySelector('header') || document.querySelector('.header')
    return header ? header.offsetHeight : 0
  }

  function showCollectionLoading() {
    main.classList.add('is-loading')
  }

  function markScrollToTabContentsAfterNavigation() {
    try {
      sessionStorage.setItem(scrollStorageKey, '1')
    } catch (e) {
      // sessionStorage が使えない環境では何もしない
    }
  }

  function scrollToTabContents() {
    const tabContents = main.querySelector('.tab_contents')
    if (!tabContents) return

    const top = tabContents.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight()

    window.scrollTo({
      top,
      behavior: 'auto',
    })
  }

  function activateCollectionTab(tabName) {
    let activeButton = null

    mainTabButtons.forEach((button) => {
      const isCurrent = button.dataset.tab === tabName
      button.classList.toggle('is-current', isCurrent)

      if (isCurrent) {
        activeButton = button
      }
    })

    mainTabContents.forEach((content) => {
      content.classList.toggle('is-current', content.dataset.tabContent === tabName)
    })

    if (activeButton && tabTitles.length) {
      const label = activeButton.querySelector('.tab_btn_label')
      if (label) {
        tabTitles.forEach((title) => {
          title.textContent = label.textContent.trim()
        })
      }
    }

    if (tabInput) {
      tabInput.value = tabName
    }
  }

  function moveCollectionTab(tabName) {
    if (!tabName) return

    const url = new URL(window.location.href)
    url.searchParams.set('tab', tabName)

    var filterKeysToClear = [
      'keyword',
      'minYear',
      'maxYear',
      'year_from',
      'year_to',
      'production_period',
      'sortOrder',
      'isAvailable',
      'artworksPage',
      'collectionPage',
      'resetFilters',
    ]

    filterKeysToClear.forEach(function (key) {
      url.searchParams.delete(key)
    })

    showCollectionLoading()
    window.location.href = url.toString()
  }

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
  }

  if (mainTabButtons.length && mainTabContents.length) {
    const params = new URLSearchParams(window.location.search)
    const initialTab = params.get('tab')
    const validTabs = Array.from(mainTabButtons).map((button) => button.dataset.tab)

    if (initialTab && validTabs.includes(initialTab)) {
      activateCollectionTab(initialTab)
    } else if (validTabs.length) {
      activateCollectionTab(validTabs[0])
    }

    mainTabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        moveCollectionTab(this.dataset.tab)
      })
    })
  }

  /**
   * 検索・ページネーション後は .tab_contents まで戻す
   */
  const params = new URLSearchParams(window.location.search)

  let shouldScrollToTabContents = params.has('artworksPage') || params.has('collectionPage')

  try {
    if (sessionStorage.getItem(scrollStorageKey) === '1') {
      sessionStorage.removeItem(scrollStorageKey)
      shouldScrollToTabContents = true
    }
  } catch (e) {
    // sessionStorage が使えない環境では何もしない
  }

  if (shouldScrollToTabContents) {
    requestAnimationFrame(() => {
      scrollToTabContents()
    })
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function () {
      showCollectionLoading()
      markScrollToTabContentsAfterNavigation()
    })
  }

  document.addEventListener('click', function (event) {
    const paginationLink = event.target.closest('.collection .pagination a')
    if (!paginationLink) return

    showCollectionLoading()
    markScrollToTabContentsAfterNavigation()
  })
})
